import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import * as Button from '../../components/Atoms/Button';
import Claim from '../../services/ClaimService';
import { CommonUtil } from '../../utils/commonUtil';
import { BlockUI } from 'primereact/blockui';
import { Dropdown } from 'primereact/dropdown';
import JSZip from 'jszip';
import _, { wrap } from 'lodash';
import { saveAs } from 'file-saver';
import {
  useRecoilValueLoadable,
  useRecoilValue,
  useSetRecoilState,
} from 'recoil';
import { myInfoSelector } from '../../recoil/selectors';
import { ServiceProvider } from '../../services/index';
import { Partner } from '../../services/PartnerService';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import {
  CENTER_DOCS,
  DOC_TYPE,
  REPAIR_DOCS,
} from '../../constants/Constants.js';
import { shopListState } from '../../recoil/atoms.js';
import { Shop } from '../../services/CodeService.js';
import { Image } from 'primereact/image';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useReactToPrint } from 'react-to-print';
import { Calendar } from 'primereact/calendar';
import { Divider } from 'primereact/divider';

const kakaoService = ServiceProvider.kakao;
const partnerService = ServiceProvider.partner;

const BillingDialog = () => {
  const reportRef = useRef();

  const myInfo = useRecoilValueLoadable(myInfoSelector);
  const partner = myInfo.contents.roleCode === 'D_ADM';
  const aid = myInfo.contents.associationInfo?.associationId;
  const history = useHistory();
  const oldData = history.location.pathname.includes('/old/');
  const today = dayjs(new Date()).format('YYYY-MM-DD');
  const [showModal, setShowModal] = useState(false);
  const [showCarInfoModal, setShowCarInfoModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({
    carNbr: '',
    carVIN: '', // 차대번호
    newCarNbr: '', // 변경된 차량번호
    customerName: '', // 소유자
    customerContact: '', // 연락처
    association: { value: '' },
    warranty: { value: '' },
    receiptDate: null, // 접수일자
    addType: { value: '' },
    note: '', //  증상 입력
    vehicleValue: '', // 차량가액
    checkDate: '', // 점검일자
    checkDistance: '', // 성능 킬로수
    distanceDriven: '', // 접수 킬로수
    buyDate: '', // 인도일자
    elapsedDays: '', // 경과일수
  });
  const [detailData, setDetailData] = useState({}); // claimData 기존고객
  const [docs, setDocs] = useState([]); // claimDocs
  const [partnerDocs, setPartnerDocs] = useState([]); // partnerDocs
  const [carDetailData, setCarDetailData] = useState(null); // 자동자 상세정보
  const [carAddress, setCarAddress] = useState(''); // 차량 위치
  const [warrantyData, setWarrantyData] = useState({
    buyDate: null,
    checkDistance: 0,
    distanceDriven: 0,
    diagnosisType: [],
    reservationDate: '',
    producingCountry: 'D',
    carName: '',
    partnerInfo: [
      {
        partnerName: '',
        partnerType: '', // 진단점 P_D, 수리점 P_R, 둘다 P_DR
        claimStatusCode: '',
        receiptDate: '',
        dueDate: '',
        paymentAmt: 0,
        carNbr: '',
        statementNumber: '',
        checkDate: '',
        partnerId: 0,
        repairCode: '',
        reservationDate: '',
        documentGroupId: '',
        useYn: '',
        fileData: [],
      },
    ],
    radius: 0,
    partnerNote: '', // opt
  });
  const [shopId, setShopId] = useState(0);
  const [funnelsType, setFunnelsType] = useState({
    value: 'WC',
    label: '전화 / 소비자',
  });
  const [carYX, setCarYX] = useState('');
  const [partnerList, setPartnerList] = useState([]);
  const [partnerAllList, setPartnerAllList] = useState([]);
  const [fileItems, setFileItems] = useState([]); // 모든 사진 파일
  const [deleteImgs, setDeleteImgs] = useState([]); // 모든 삭제하는 사진 파일
  const [partnerDeleteImgs, setPartnerDeleteImgs] = useState([]); // 삭제하는 파트너 파일
  const [copyFile, setCopyFile] = useState([]);
  const [partnerFile, setPartnerFile] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState([]);
  const [statusCode, setStatusCode] = useState('Z01');
  const [toggleStates, setToggleStates] = useState([
    { idx: 3, status: 'Z03', value: false }, // 서류완료
    { idx: 4, status: 'Z04', value: false }, // 거절완료
    { idx: 5, status: 'Z05', value: false }, // 입고안내 완료
    { idx: 6, status: 'Z06', value: false }, // 입고점검 완료 - 진단점앱에서 사진 올라온 경우
    { idx: 7, status: 'Z07', value: false }, // 수리중 - 승인견적서, 승인 보내기 완료 시
    { idx: 8, status: 'Z08', value: false }, // 수리완료 - 진단점앱에서 수리사진 올라온 경우
  ]);

  const [repairData, setRepairData] = useState({
    date: '',
    maintenanceCode: '',
    workYN: '',
    workFee: null, // int
    repairNote: '',
  }); // 수리정보

  const [insuranceInfo, setInsuranceInfo] = useState({
    payDate: '',
    paymentAmt: null, // int
    deductibleAmt: null, // int
    completeDate: '',
    insurancePolicyNumber: '', // 증권번호
    code: '10',
  });

  const [consultationList, setConsultationList] = useState([]);
  const [showSmsMoal, setShowSmsModal] = useState(false);
  const [showSmsType, setShowSmsType] = useState('');
  const [showPushModal, setShowPushModal] = useState(false);
  const [partnerInfo, setPartnerInfo] = useState(null);
  const [showPushType, setShowPushType] = useState('');
  const [smsData, setSmsData] = useState({
    msgType: '',
    sourceAddr: '15332729',
    msgSubType: null,
    destAddr: '',
    subject: null, //opt,
    contents: '',
    fileData: null, //opt
    url: null, // opt
  });
  const [oriCarAddress, setOriCarAddress] = useState('');
  const [newStatusCode, setNewStatusCode] = useState(null);
  const { id } = useParams();
  const [carInfo, setCarInfo] = useState([]);
  const [userNames, setUserNames] = useState({
    firstId: '',
    firstName: '',
    lastId: '',
    lastName: '',
  });

  // const handleToggleButton = (name, checked) => {
  //   if (!detailData?.dataId) return;
  //   setToggleStates((prev) =>
  //     prev.map((state) =>
  //       state.status === name ? { ...state, value: checked } : state
  //     )
  //   );

  //   if (!checked) {
  //     const idx = Number(name.slice(1, 3));
  //     if (idx === 4 || idx === 5) {
  //       setStatusCode(`Z03`);
  //       setNewStatusCode(`Z03`);
  //     } else {
  //       setStatusCode(`Z0${idx - 1}`);
  //       setNewStatusCode(`Z0${idx - 1}`);
  //     }
  //   } else {
  //     setStatusCode(name);
  //     setNewStatusCode(name);
  //   }
  // };

  // 경과일 수 계산 코드
  function calculateElapsedDays(targetDateString) {
    const today = dayjs();
    const targetDate = dayjs(targetDateString);
    const elapsedDays = today.diff(targetDate, 'day');
    return elapsedDays;
  }

  // 이미지 컴포넌트
  const ImageBox = React.memo(
    ({ title, code, partner = false, partnerData }) => {
      const countFilesByCode = (docsArray, code) => {
        if (docsArray)
          return docsArray.filter((doc) => doc.documentCode === code);
      };
      let filterDocs;
      if (partner && partnerData) {
        filterDocs = countFilesByCode(partnerData, code);
      } else {
        filterDocs = countFilesByCode(docs, code);
      }
      const isSingle = filterDocs.length <= 1;

      return (
        <div className={isSingle ? 'imageBox half' : 'imageBox full'}>
          <p className="section_sub_title">{title}</p>
          <div className={!isSingle ? 'twice-grid' : ''}>
            {filterDocs.map((doc) => {
              const isPdfDoc =
                doc.originalFileName?.toLowerCase().endsWith('.pdf') ||
                doc.filePath?.toLowerCase().endsWith('.pdf');
              const openViewer = () => {
                sessionStorage.setItem(
                  'images',
                  JSON.stringify(filterDocs)
                );
                CommonUtil.Window.popup(
                  '/compensation/accident/claim/viewer',
                  '',
                  window.innerWidth * 0.9,
                  window.innerHeight * 0.9
                );
              };
              return (
                <div
                  key={doc.imgId}
                  className="image-container"
                  onClick={openViewer}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) =>
                    e.key === 'Enter' && openViewer()
                  }
                  style={{ cursor: 'pointer' }}
                >
                  {isPdfDoc ? (
                    <div
                      className="flex flex-column align-items-center justify-content-center gap-2 p-3 border-1 border-200 border-round"
                      style={{ minHeight: '120px' }}
                    >
                      <i
                        className="pi pi-file-pdf"
                        style={{ fontSize: '2rem', color: '#d32f2f' }}
                      />
                      <span className="text-sm">{doc.originalFileName}</span>
                    </div>
                  ) : (
                    <img
                      src={(() => {
                        const base = doc.file_server ?? doc.fileServer ?? process.env.REACT_APP_FILE_SERVER_URL ?? process.env.REACT_APP_S3_BASE_URL ?? '';
                        const path = (doc.filePath || '').trim();
                        if (!path) return base;
                        const baseNorm = String(base).replace(/\/$/, '');
                        const pathPart = path.startsWith('/') ? path : `/${path}`;
                        return `${baseNorm}${pathPart}`;
                      })()}
                      alt={doc.originalFileName}
                      style={{ width: '100%' }}
                    />
                  )}
                </div>
              );
            })}
            {/* 이미지 없을 경우 */}
            {filterDocs.length === 0 && (
              <div className="empty-container">
                <p>NO IMAGE</p>
              </div>
            )}
          </div>
        </div>
      );
    }
  );

  useEffect(() => {
    if (!!newStatusCode) {
      registerClaim('수정');
    }
  }, [newStatusCode]);

  useEffect(() => {
    if (statusCode) {
      const index = Number(statusCode.slice(1, 3));
      setToggleStates((prevStates) =>
        prevStates.map((state) => {
          if (state.idx <= index) {
            return { ...state, value: true };
          } else {
            return { ...state, value: false };
          }
        })
      );
    }
  }, [statusCode]);

  const getAddressInfo = async (address) => {
    try {
      const {
        documents: [res],
      } = await kakaoService.getAddressInfo({
        query: address,
      });
      if (res) {
        const coordinates = `${res.y},${res.x}`;
        setCarYX(coordinates);
        return coordinates;
      } else {
        setCarYX('');
        return null;
      }
    } catch (error) {
      console.error(error);
      setCarYX('');
      return null;
    }
  };
  const [partnerAllType, setPartnerAllType] = useState([]);
  const getPartnerAllType = async () => {
    try {
      const data = await Claim.getDocsType('R');
      setPartnerAllType(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPartnerAllType();
  }, []);

  const getPartnerList = async (location, radius, aid) => {
    try {
      const data = await Partner.nearList({
        aids: aid ?? 1,
        page: 1,
        size: 200,
        carRadius: Number(radius),
        carLocation: location,
      });

      if (data) {
        partnerListSetting(data.data.list);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const partnerListSetting = (data) => {
    const filter = data.filter((el) => el.useYn === 'Y');
    const list = [];
    filter.map((el) =>
      list.push({
        partnerName: `${el.partnerName} (${partnerAllType
          .filter((item) =>
            el.partnerRepairType.split(',').includes(item.value)
          )
          .map((item) => item.label)}) ${
          el.partnerShip === 'Y' ? '/ 제휴' : '/ 비제휴'
        }`,
        partnerId: el.partnerId,
        partnerRepairType: el.partnerRepairType,
        cellphone: el.cellphone,
        address: el.address,
        partnerShip: el.partnerShip,
      })
    );
    return setPartnerList(list);
  };

  const getPartnerAllList = async (aid) => {
    try {
      const data = await partnerService.list({
        aids: aid ?? 1,
        page: 1,
        size: 200,
        useYN: 'Y',
      });
      if (data) {
        setPartnerAllList(data.data.list);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!!carYX && typeof warrantyData.radius === 'number' && !!aid) {
      getPartnerList(carYX, warrantyData.radius, aid);
    } else if (warrantyData.radius === '전체' && !!partnerAllList) {
      partnerListSetting(partnerAllList);
    }
  }, [carYX, warrantyData.radius, aid]);

  useEffect(() => {
    if (!!aid && !oldData) {
      getPartnerAllList(aid);
    }
  }, [aid, oldData]);

  const [statusList, setStatusList] = useState([]);
  const getStatusList = async () => {
    try {
      const data = await Claim.getDocsType('Z');
      setStatusList(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const setShopListState = useSetRecoilState(shopListState);
  const shopList = useRecoilValue(shopListState);
  const getShopList = async (eids) => {
    try {
      const data = await Shop.getList({ eids: eids });
      if (data) {
        setShopListState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!!myInfo.contents.associationInfo && !oldData) {
      getShopList(myInfo.contents.associationInfo.associationId);
    }
  }, [myInfo.contents, oldData]);

  const [insuranceList, setInsuranceList] = useState([]);
  const getInsuranceList = async () => {
    try {
      const data = await Claim.getInsurances();
      const list = data.filter(
        (el) =>
          el.label?.includes('KB') ||
          el.label?.includes('DB') ||
          el.label?.includes('삼성')
      );
      setInsuranceList(list);
    } catch (error) {
      console.log(error);
    }
  };

  function findLabelByCode(data, code) {
    const result = data.find((item) => item.codeData.insuranceCode === code);
    return result ? result.label : null;
  }

  useEffect(() => {
    if (!oldData) {
      getInsuranceList();
    }
    getStatusList();
  }, [oldData]);

  useEffect(() => {
    if (history.location.state) {
      setCustomerInfo(history.location.state.customerInfo);
    }
  }, [history.location.state]);

  const getDetailData = async (dataId) => {
    setLoading(true);
    try {
      const data = oldData
        ? await Claim.getDetailOld(dataId)
        : await Claim.getDetail(dataId);
      if (data) {
        if (data.claimData.carLocation) {
          setCarYX(data.claimData.carLocation);
        } else if (data.claimData.carAddress && !oldData) {
          getAddressInfo(data.claimData.carAddress);
        }
        if (data.claimData.carAddress) {
          setCarAddress(data.claimData.carAddress);
          setOriCarAddress(data.claimData.carAddress);
        }
        if (data.claimData.funnelsType) {
          const type = FUNNELS_TYPE.find(
            (el) => el.value === data.claimData.funnelsType
          );
          setFunnelsType(type ? type : { label: '', value: '' });
        }
        if (data.claimData.shopId) {
          setShopId(data.claimData.shopId);
        }

        setDetailData(data.claimData);
        setDocs(data.claimDocuments);
        setPartnerDocs(data?.claimData?.partnerInfo[0]?.partnerDocuments);
        setCustomerInfo({
          carName: data.claimData?.carName ?? '',
          newCarNbr: data.claimData?.newCarNbr ?? '',
          customerName: data.claimData?.customerName ?? '',
          customerContact: data.claimData?.customerContact ?? '',
          carVIN: data.claimData?.vin ?? '',
          carNbr: data.claimData?.carNbr ?? '',
          association: {
            value: !!data.claimData?.checkFlag
              ? data.claimData.checkFlag === 'Y'
                ? 'association'
                : 'non_association'
              : null,
          },
          warranty: {
            value: !!data.claimData?.assuranceType
              ? data.claimData.assuranceType === '2'
                ? 'warranty'
                : 'warranty_s'
              : null,
          },
          receiptDate: data.claimData?.receiptDate
            ? CommonUtil.Formatter.stringToDayForm(data.claimData.receiptDate)
            : today,
          addType: {
            value: data.claimData?.addType ?? '',
          },
          note: data.claimData?.note ?? '',
          vehicleValue: formatNumber(data.claimData?.vehicleValue) ?? '',
          checkData: data.claimData?.checkData ?? null,
          checkDistance: data.claimData?.checkDistance ?? null,
          distanceDriven: data.claimData?.distanceDriven ?? null,
          buyDate: data.claimData?.buyDate
            ? CommonUtil.Formatter.stringToDayForm(data.claimData.buyDate)
            : null,
          elapsedDays: data.claimData?.buyDate
            ? calculateElapsedDays(data.claimData.buyDate)
            : 0,
        });
        setWarrantyData({
          buyDate: !!data.claimData.buyDate ? data.claimData.buyDate : null,
          checkDistance: data.claimData.checkDistance,
          distanceDriven: data.claimData.distanceDriven,
          diagnosisType: data.claimData.diagnosisType
            ? data.claimData.diagnosisType
            : null,
          reservationDate: data.claimData.reservationDate,
          producingCountry: data.claimData.producingCountry,
          carName: data.claimData.carName,
          partnerInfo: data.claimData.partnerInfo
            ? data.claimData.partnerInfo
            : null,
          partnerNote: data.claimData.partnerNote,
        });
        setStatusCode(
          data.claimData.claimStatus === 'Z1'
            ? 'Z01'
            : data.claimData.claimStatus
        );
        setRepairData({
          date: data.claimData.partnerReceiptDate
            ? CommonUtil.Formatter.stringToDate(
                data.claimData.partnerReceiptDate
              )
            : '',
          maintenanceCode: data.claimData.maintenanceCode
            ? data.claimData.maintenanceCode.split(',')
            : '',
          workYN: data.claimData.workYN,
          workFee: data.claimData.workFee,
          repairNote: data.claimData.repairNote,
          repairOpinion: data.claimData.repairOpinion
            ? data.claimData.repairOpinion
            : '',
        });

        setInsuranceInfo({
          payDate: data.claimData.insurancePurchaseDate
            ? CommonUtil.Formatter.stringToDate(
                data.claimData.insurancePurchaseDate
              )
            : null,
          paymentAmt: data.claimData.insurancePaymentAmt, // int
          deductibleAmt: data.claimData.deductibleAmt, // int
          completeDate: data.claimData.completeDate
            ? CommonUtil.Formatter.stringToDate(data.claimData.completeDate)
            : null,
          insurancePolicyNumber: data.claimData.insurancePolicyNumber
            ? data.claimData.insurancePolicyNumber
            : '',
          code: data.claimData.insuranceCode
            ? data.claimData.insuranceCode
            : insuranceInfo.code,
        });
      }
      if (myInfo.contents) {
        setUserNames({
          firstId: data.claimData.receiptId ?? null,
          firstName: data.claimData.receiptName
            ? data.claimData.receiptName
            : null,
          lastId: myInfo.contents.userId,
          lastName: myInfo.contents.userName,
        });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (myInfo.contents) {
      setUserNames({
        ...userNames,
        lastId: myInfo.contents.userId,
        lastName: myInfo.contents.userName,
      });
    }
  }, [myInfo.contents]);

  const filterPartnerTypeOptions = (partnerAllType, repairCodes) => {
    if (!repairCodes) return [];
    return partnerAllType
      .filter((item) => repairCodes.includes(item.value))
      .map((item) => item.label)
      .toString();
  };

  //ANCHOR - set partner info
  useEffect(() => {
    if (!!warrantyData.partnerInfo.length && !!partnerAllList.length) {
      const data = warrantyData.partnerInfo
        .map((el) => {
          const partner = partnerAllList.find(
            (partner) => Number(el.partnerId) === partner.partnerId
          );
          if (partner) {
            let newSelectPartner = {
              partnerName: partner?.partnerName,
              partnerType: el?.partnerType.split(',') ?? '', // 진단점 P_D, 수리점 P_R, 둘다 P_DR
              claimStatusCode: el?.claimStatusCode ?? null,
              receiptDate: el?.receiptDate
                ? CommonUtil.Formatter.stringToDate(el?.receiptDate)
                : null,
              dueDate: el.dueDate
                ? CommonUtil.Formatter.stringToDate(el.dueDate)
                : '',
              paymentAmt: el?.paymentAmt ?? null,
              checkDate: el?.checkDate ?? null,
              partnerId: partner.partnerId,
              reservationDate: el?.reservationDate
                ? CommonUtil.Formatter.stringToDate(el?.reservationDate)
                : null,
              documentGroupId: el?.documentCode ?? null,
              useYn: 'Y',
              address: partner.address,
              cellphone: partner.cellphone,
              isOriginal: true,
              partnerDocuments: el.partnerDocuments,
              partnerShip: partner?.partnerShip,
            };
            newSelectPartner.repairCodesName = filterPartnerTypeOptions(
              partnerAllType,
              partner.partnerRepairType.split(',')
            );
            newSelectPartner.repairCodes = el.repairCode
              ? el.repairCode.split(',')
              : [];
            return newSelectPartner;
          }
          return null;
        })
        .filter(Boolean);
      setSelectedPartner(data.flat());
    } else {
      setSelectedPartner([]);
    }
  }, [warrantyData.partnerInfo, partnerAllList, partnerAllType]);

  useEffect(() => {
    if (docs) {
      setFileItems(docs);
      setCopyFile(docs);
    }
  }, [docs]);

  //ANCHOR -  클레임 POST, PUT
  const registerClaim = async (type) => {
    if (oldData) {
      return;
    }
    setLoading(true);

    const fileData = [];
    const files = [];
    const pfiles = [];

    let fileDataList = [];
    let filesList = [];

    if (type === '저장') {
      fileItems.map((el) =>
        fileData.push({
          documentCode: el.documentCode,
          state: el.state,
        })
      );
      fileItems.map((el) => files.push(el.file));
    } else if (type === '수정') {
      const del = [];
      if (!!deleteImgs.length) {
        const imgs = deleteImgs.filter((el) => !!el.imgId);

        if (!!imgs.length) {
          imgs.map((el) =>
            del.push({
              imgId: el.imgId,
              documentCode: el.documentCode,
              state: 'D',
            })
          );
        }
        fileDataList = del;
      }

      const findFile = fileItems.find((el) => el.file);
      const findImgId = fileItems.find((el) => el.imgId);
      const idFile = [];
      fileItems.filter((el) => el.imgId && idFile.push(el));
      const imgFile = [];
      fileItems.filter((el) => el.file && imgFile.push(el));

      if (findFile && !findImgId) {
        fileItems.map((el) =>
          fileDataList.push({
            documentCode: el.documentCode,
            state: el.state,
          })
        );
        fileItems.map((el) => filesList.push(el.file));
      } else if (findFile && findImgId) {
        imgFile.map((el) =>
          fileDataList.push({
            documentCode: el.documentCode,
            state: el.state,
          })
        );
        const { fileData, files } =
          CommonUtil.File.convertForServerClaim(deleteImgs);
        files.map((el) => filesList.push(el));
        imgFile.map((el) => filesList.push(el.file));
      }
    }

    let partnerFiles = [];

    const modifyPartners = selectedPartner.map((partner) => {
      const { fileData, files } = CommonUtil.File.convertForServerClaimPartner(
        partner.partnerDocuments
      );
      partner.partnerDocuments = fileData;
      files.map((el) => partnerFiles.push(el));
      return partner;
    });

    let partnerInfoData = [];
    if (!!modifyPartners) {
      partnerInfoData = modifyPartners.map((el) => ({
        partnerName: el?.partnerName?.split(' (')[0],
        carNbr: customerInfo.carNbr,
        statementNumber: !!carDetailData
          ? carDetailData?.statementNumber
          : null,
        checkDate: !!carDetailData ? carDetailData.checkDate : null,
        partnerId: el.partnerId,
        repairCode: el.repairCodes?.toString(),
        reservationDate: !!el.reservationDate
          ? CommonUtil.Formatter.dateToString(el.reservationDate)
          : null,
        useYn: el.useYn,
        documentGroupId: detailData?.documentGroupId ?? null,
        fileData: el.partnerDocuments ?? [],
        partnerType: 'P_DR',
        claimStatusCode: el?.claimStatusCode ?? null,
        receiptDate: !!el.receiptDate
          ? CommonUtil.Formatter.dateToString(el.receiptDate)
          : null,
        dueDate: !!el?.dueDate ? dayjs(el?.dueDate).format('YYYYMMDD') : null,
        paymentAmt: !!el?.paymentAmt ? Number(el?.paymentAmt) : null,
        partnerShip: el.partnerShip ?? 'N',
      }));
    }

    let coordinates = '';
    if (type === '수정') {
      if (carAddress !== '') {
        if (oriCarAddress !== carAddress) {
          coordinates = await getAddressInfo(carAddress);
          if (!coordinates) {
            setLoading(false);
            window.cerp.toast.warn(
              '존재하지 않는 주소입니다. 주소를 확인해주세요.'
            );
            return;
          }
        } else {
          coordinates = carYX; // 동일한 주소
        }
      }
    }

    const Data = {
      dataId: detailData?.dataId ?? null,
      shopId: !!shopId ? shopId : null,
      associationId: aid,
      addType:
        customerInfo?.addType?.value === 'null'
          ? null
          : customerInfo?.addType?.value, // B 법인, L 리스, F 외판 opt
      funnelsType: funnelsType.value, // W or A
      claimStatus: statusCode,
      customerName: customerInfo?.customerName,
      customerContact: customerInfo?.customerContact.replace(/[^0-9]/g, ''),
      checkFlag: customerInfo?.association.value === 'association' ? 'Y' : 'N',
      assuranceType: customerInfo?.warranty.value === 'warranty' ? '2' : '1',
      statementNumber: !!carDetailData ? carDetailData?.statementNumber : null, // opt
      carNbr: customerInfo.carNbr ?? null,
      vin: !!customerInfo?.carVIN ? customerInfo?.carVIN : null,
      newCarNbr: customerInfo.newCarNbr
        ? customerInfo.newCarNbr
        : detailData.newCarNbr
        ? detailData.newCarNbr
        : null,
      vehicleValue: !!customerInfo.vehicleValue
        ? Number(customerInfo.vehicleValue)
        : null,
      checkDate: !!carDetailData ? carDetailData?.checkDate : null, // opt
      buyDate:
        warrantyData.buyDate && typeof warrantyData.buyDate !== 'string'
          ? CommonUtil.Formatter.dateToString(warrantyData.buyDate)
          : !!warrantyData.buyDate
          ? warrantyData.buyDate
          : null,
      checkDistance: warrantyData.checkDistance
        ? Number(warrantyData.checkDistance)
        : null, //vehicleInformation > TRVL_DSTNC
      distanceDriven: warrantyData.distanceDriven
        ? Number(warrantyData.distanceDriven)
        : null,
      producingCountry: warrantyData.producingCountry
        ? warrantyData.producingCountry
        : null, // D or F // opt
      carName: warrantyData.carName ? warrantyData.carName : null,
      carAddress: carAddress ? carAddress : null,
      carLocation: coordinates, //Opt
      diagnosisType:
        warrantyData.diagnosisType &&
        typeof warrantyData.diagnosisType === 'string'
          ? warrantyData.diagnosisType
          : warrantyData.diagnosisType && !!warrantyData.diagnosisType.length
          ? warrantyData.diagnosisType.join()
          : null, // 진단타입 B, D..
      consultationGroupId: detailData?.consultationGroupId
        ? detailData?.consultationGroupId
        : null,
      partnerInfo: !!partnerInfoData.length ? partnerInfoData : null, //Opt 진단점 목록
      receiptId: userNames.firstId ? userNames.firstId : myInfo.contents.userId,
      receiptName: userNames.firstName
        ? userNames.firstName
        : myInfo.contents.userName,
      receiptDate: customerInfo?.receiptDate
        ? dayjs(customerInfo.receiptDate).format('YYYYMMDD')
        : dayjs(today).format('YYYYMMDD'),
      documentGroupId: type === '저장' ? null : detailData?.documentGroupId, //Opt
      note: customerInfo.note ?? null, //Opt
      partenerReceiptDate: detailData?.partenerReceiptDate ?? null, //Opt 수리 입고일자
      maintenanceCode: !!repairData.maintenanceCode.length
        ? repairData.maintenanceCode.join()
        : null,
      workYN: repairData.workYN ? repairData.workYN : null, //Opt 수리여부
      workFee: repairData.workFee ? Number(repairData.workFee) : null, //Opt 협의비용
      insuranceCode: insuranceInfo.code, // opt 보험코드
      insurancePolicyNumber: insuranceInfo.insurancePolicyNumber ?? null, //opt 증권번호
      insurancePurchaseDate: insuranceInfo.payDate
        ? CommonUtil.Formatter.dateToString(insuranceInfo.payDate)
        : null, // Opt 보험료 지급일
      insurancePaymentAmt: insuranceInfo.paymentAmt ?? null, //Opt 보험료
      deductibleAmt: insuranceInfo.deductibleAmt ?? null, // opt 자기부담금
      partnerNote: warrantyData.partnerNote ? warrantyData.partnerNote : null, //Opt
      repairNote: repairData.repairNote ? repairData.repairNote : null,
      repairOpinion: repairData.repairOpinion ? repairData.repairOpinion : null, // Opt 소견내용
      completeYN: insuranceInfo.completeDate ? 'Y' : 'N', //Opt 완료여부
      completeDate: insuranceInfo.completeDate
        ? CommonUtil.Formatter.dateToString(insuranceInfo.completeDate)
        : null, //Opt 완료일
      completeLoginId: myInfo.contents.loginId, //Opt 로그인유저 아이디
      completeName: myInfo.contents.userName, //Opt 로그인유저 이름
      completeLoginContact: myInfo.contents.contact, //opt 로그인유저 연락처
      fileData: type === '저장' ? fileData : fileDataList, //Otp
    };

    const checkData =
      !!Data.funnelsType &&
      !!Data.checkFlag &&
      !!Data.assuranceType &&
      !!Data.customerName &&
      !!Data.customerContact &&
      !!Data.carNbr &&
      !!Data.receiptDate;

    if (!checkData) {
      setLoading(false);
      window.cerp.toast.warn('필수 입력값을 입력해주세요.');
      return;
    }

    try {
      if (type === '저장') {
        const data = await Claim.registerClaim(Data, files, pfiles);
        if (data) {
          window.cerp.toast.success('등록이 완료 되었습니다.');
          history.replace(
            `/compensation/accident/claim/detail/${data.data.dataId}`
          );
          sessionStorage.removeItem('images');
          setLoading(false);
        }
      } else if (type === '수정') {
        const data = await Claim.updateClaim(Data, filesList, partnerFiles);
        if (data) {
          window.cerp.toast.success('저장이 완료 되었습니다.');
          getDetailData(data.dataId);
          setDeleteImgs([]);
          setPartnerDeleteImgs([]);
          sessionStorage.removeItem('images');
          setLoading(false);
          setNewStatusCode(null);
          setFileItems([]);
        }
      }
    } catch (error) {
      console.log(error);
      window.cerp.toast.error(
        '저장 실패',
        '페이지 새로고침 후 다시 시도해주세요.'
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!!id && id !== 'new') {
      getDetailData(id);
    }
  }, [id]);

  const NEW = id === 'new';

  const formatNumber = (number) => {
    return new Intl.NumberFormat('ko-KR').format(number);
  };

  const checkWarranty = async (carNum, vin) => {
    setLoading(true);
    try {
      const data = await Claim.getCheckWarranty(
        carNum,
        vin
      );
      if (data) {
        // if (data.length === 1) {
          const info = data.performanceCheckData;
          setCarDetailData(info);
          setCustomerInfo({
            ...customerInfo,
            association: { value: 'association' },
            carVIN: info.vin,
          });
          setShopId(info.shopId);
          setCarInfo(data);
        // } else {
        //   setCarInfo(data);
        // }
      }
    } catch (error) {
      console.log(error);
      // window.cerp.toast.warn(error?.response?.data?.error?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (customerInfo.carNbr && !oldData) {
      checkWarranty(
        customerInfo.carNbr,
        customerInfo.carVIN
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerInfo.carNbr, detailData?.statementNumber]);

  const getList = async (id) => {
    try {
      const data = await Claim.getConsultation({
        page: 1,
        size: 10,
        consultationGroupId: id,
      });
      setConsultationList(data.list);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!!detailData?.consultationGroupId) {
      getList(detailData?.consultationGroupId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailData?.consultationGroupId]);

  const filterDocuments = (partnerDocuments, documentCode) => {
    return partnerDocuments?.filter((doc) => doc.documentCode === documentCode);
  };

  const [downloadLoading, setDownloadLoading] = useState(false);
  const saveFilesAsZip = async () => {
    window.cerp.toast.info('다운로드를 시작합니다.');

    const partnerFiles = [];
    selectedPartner.map((partner) =>
      partner.partnerDocuments.map((doc) => partnerFiles.push(doc))
    );

    const folderName = customerInfo.carNbr;
    const files = fileItems.concat(partnerFiles);
    const haveIds = [];
    files.map((el) => (el.imgId ? haveIds.push(el.imgId) : null));
    if (!files.length) return window.cerp.toast.warn('서류가 없습니다.');
    if (!haveIds.length)
      return window.cerp.toast.warn('클레임 저장 후 가능합니다.');
    const zip = new JSZip();
    const imagesFolder = zip.folder(folderName);

    const getExtFromFile = (file) => {
      const pathName = file?.filePath || '';
      const originalName = file?.originalFileName || file?.file?.name || '';
      const source = pathName || originalName;
      const dotIndex = source.lastIndexOf('.');
      if (dotIndex > -1) return source.substring(dotIndex).toLowerCase();
      return '.jpg';
    };

    const reportPDF = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
      compress: true,
    });

    const papers = reportRef.current.querySelectorAll('.paper');
    const pdfWidth = 297;
    const pdfHeight = 210;

    if (papers.length > 0) {
      const now = dayjs().format('YYYY-MM-DD HH:mm:ss');

      for (let i = 0; i < papers.length; i++) {
        const page = papers[i];

        const canvas = await html2canvas(page, {
          scale: 2,
          logging: true,
          allowTaint: true,
          useCORS: true,
          imageTimeout: 0,
          backgroundColor: 'transparent',
        });

        const pageImage = canvas.toDataURL('image/png');
        const imgWidth = 297 - 20;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        const x = (pdfWidth - imgWidth) / 2; // 가로 중앙 정렬

        reportPDF.addImage(pageImage, 'PNG', x, 0, imgWidth, imgHeight);
        if (i < papers.length - 1) {
          reportPDF.addPage();
        }
      }
    }

    const pdfBlob = reportPDF.output('blob');
    imagesFolder.file(`차량 기본 정보, 마감 정보.pdf`, pdfBlob);

    const imagePromises = files
      .filter((file) => file.documentCode !== 'C_FRONT')
      .map(async (file, index) => {
        let docType = DOC_TYPE.find((doc) => doc.value === file.documentCode);
        if (file.documentCode === 'C_ORIGINALDOCS') {
          docType = {
            ...docType,
            category: '매매상사접수서류',
            label: '자동차등록원부(갑)',
          };
        }
        const ext = getExtFromFile(file);
        const fileName = docType
          ? `${docType.category}/${index + 1}_${docType.label}${ext}`
          : `${index + 1}_${file.documentCode}${ext}`;
        const imgBlob = await Claim.getBlobFromUrl(file.filePath);
        imagesFolder.file(fileName, imgBlob, { binary: true });
      });
    await Promise.all(imagePromises);
    zip.generateAsync({ type: 'blob' }).then(function (content) {
      saveAs(content, `${folderName}.zip`);
    });
    window.cerp.toast.success('다운로드가 완료되었습니다.');
  };

  useEffect(() => {
    if (!!selectedPartner.length) {
      const initValue = 0;
      const sumValeu = selectedPartner
        .filter((el) => el.useYn === 'Y')
        ?.reduce(
          (acc, cur) =>
            Number(acc) + Number(cur?.paymentAmt ? cur?.paymentAmt : 0),
          initValue
        );

      setInsuranceInfo({ ...insuranceInfo, paymentAmt: sumValeu });
    } else {
      setInsuranceInfo({ ...insuranceInfo, paymentAmt: 0 });
    }
  }, [selectedPartner.length, selectedPartner, warrantyData.partnerInfo]);

  const handlePrint = useReactToPrint({
    content: () => {
      const papers = reportRef.current.querySelectorAll('.paper');
      if (papers.length === 0) return false;

      return reportRef.current;
    },
    onBeforePrint: async () => {
      setLoading(true);
    },
    onAfterPrint: () => {
      setLoading(false);
    },
  });

  return (
    <div ref={reportRef}>
      <BlockUI
        fullScreen
        template={
          loading && (
            <i className="pi pi-spin pi-spinner text-white-alpha-90 font-bold text-6xl" />
          )
        }
        blocked={loading}
      ></BlockUI>
      <div className="px-3 py-2 fixed surface-200 w-full z-5 border-bottom-1 border-400">
        <div className="flex md:justify-content-between justify-content-start">
          <div className="flex align-items-center gap-2 ">
            <div className="font-bold ml-2 text-xl md:block hidden">
              성능 보험 지급 관리
            </div>
          </div>
          <div className="flex gap-4">
            {partner ? null : (
              <div className="flex gap-2">
                <div className="flex align-items-center">*업무 진행상태 :</div>
                <Dropdown
                  value={statusCode}
                  onChange={(e) => {
                    setStatusCode(e.target.value);
                  }}
                  options={statusList}
                  optionLabel="label"
                  placeholder="상태 선택"
                  className="w-full md:w-16rem font-bold overflow-hidden"
                />
              </div>
            )}
            <Button.Default
              className="sm:text-lg sm:text-base"
              icon="pi pi-save"
              label={'저장'}
              disabled={oldData}
              onClick={() => registerClaim(NEW ? '저장' : '수정')}
            />
            <Button.Default
              className="sm:text-lg sm:text-base p-button-outlined"
              icon="pi pi-print"
              label={'파일 전체 다운로드'}
              disabled={oldData}
              onClick={() => saveFilesAsZip()}
            />
            <Button.Default
              className="p-button-outlined p-button-danger"
              icon="pi pi-times"
              label=""
              onClick={() => {
                sessionStorage.removeItem('images');
                sessionStorage.removeItem('data');
                if (oldData) {
                  history.push('/compensation/approval/oldlist');
                } else {
                  history.push('/compensation/billing/list');
                }
              }}
            />
          </div>
        </div>
      </div>
      <div
        id="performance-check-report"
        className="claimPaper"
        style={{ paddingTop: '4.5rem' }}
      >
        <div className="inner">
          {/* 기본 정보 테이블 */}
          <h3 className="font-bold text-center mb-3">
            한가온 성능 보험 지급 관리
          </h3>
          <div className="paper flex flex-wrap justify-content-center gap-2 pb-3">
            <table className="bg-white">
              <thead>
                <tr>
                  <th colSpan="6" className="header">
                    차량 기본 정보
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="subject">차명</td>
                  <td className="content">{customerInfo?.carName || '-'}</td>
                  <td className="subject">차량번호</td>
                  <td className="content">{customerInfo?.carNbr || '-'}</td>
                  <td className="subject">변경된 차량번호</td>
                  <td className="content">{customerInfo?.newCarNbr || '-'}</td>
                </tr>
                <tr>
                  <td className="subject">차대번호</td>
                  <td colSpan="5" className="merged">
                    {customerInfo?.carVIN || '-'}
                  </td>
                </tr>
                <tr>
                  <td className="subject">소유자</td>
                  <td className="content">
                    {customerInfo?.customerName || '-'}
                  </td>
                  <td className="subject">연락처</td>
                  <td className="content">
                    {customerInfo?.customerContact != null
                      ? CommonUtil.Formatter.phone(
                          customerInfo?.customerContact
                        )
                      : '-'}
                  </td>
                  <td className="subject">접수일자</td>
                  <td className="content">
                    {customerInfo?.receiptDate || '-'}
                  </td>
                </tr>
                <tr>
                  <td className="subject">차량 인도일 (경과일수)</td>
                  <td className="content">
                    {customerInfo?.buyDate != null
                      ? `${customerInfo?.buyDate} (${customerInfo?.elapsedDays}일 경과)`
                      : '-'}
                  </td>
                  <td className="subject">성능 킬로수</td>
                  <td className="content">
                    {customerInfo?.checkDistance != null
                      ? `${formatNumber(customerInfo?.checkDistance)}Km`
                      : '-'}
                  </td>
                  <td className="subject">접수 킬로수</td>
                  <td className="content">
                    {customerInfo?.distanceDriven != null
                      ? `${formatNumber(customerInfo?.distanceDriven)}Km`
                      : '-'}
                  </td>
                </tr>
                <tr>
                  <td className="subject">성능점검일</td>
                  <td className="content">{customerInfo?.checkDate || '-'}</td>
                  <td className="subject">차량가액</td>
                  <td colSpan="3" className="content">
                    {customerInfo?.vehicleValue != null
                      ? `${customerInfo?.vehicleValue}원`
                      : '-'}
                  </td>
                  {/* <td  className="merged"></td> */}
                </tr>
                <tr>
                  <td className="subject">증상</td>
                  <td colSpan="5" className="merged">
                    {customerInfo?.note}
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="bg-white">
              <thead>
                <tr>
                  <th colSpan="6" className="header">
                    마감정보
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="subject">청구일</td>
                  <td colSpan="5" className="content">
                    <div className=" grid lg:col-4 col align-items-center">
                      <div className="w-18rem">
                        <Calendar
                          value={insuranceInfo.completeDate}
                          onChange={(e) =>
                            setInsuranceInfo({
                              ...insuranceInfo,
                              completeDate: e.target.value,
                            })
                          }
                          dateFormat="yy-mm-dd"
                          showButtonBar
                          showIcon
                          mask="9999-99-99"
                          placeholder="청구일 선택"
                          className="w-18rem"
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="subject">보험사</td>
                  <td className="content">
                    {findLabelByCode(insuranceList, insuranceInfo.code)}
                  </td>
                  <td colSpan="2" className="subject">
                    증권번호
                  </td>
                  <td colSpan="2" className="content">
                    {insuranceInfo.insurancePolicyNumber || '-'}
                  </td>
                </tr>
                <tr>
                  <td className="subject">총 지급액</td>
                  <td colSpan="4" className="content">
                    {!!insuranceInfo.paymentAmt
                      ? `${formatNumber(insuranceInfo.paymentAmt)}원`
                      : '-'}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Divider />
          {/* 이미지 리스트 */}
          <div className="section_title">
            <p>차량 기본 사진(고객, 딜러)</p>
          </div>
          <div className="imageWrap">
            <ImageBox title={'성능기록부'} code={'S_CHECK1'} />
            <ImageBox title={'매매계약서 (업소보관용)'} code={'S_CONTRACT'} />
            <ImageBox title={'자동차등록증'} code={'C_CERTIFICATE'} />
            <ImageBox title={'자동차등록원부(갑)'} code={'S_CHECK2'} />
            <ImageBox title={'리콜'} code={'C_RECALL'} />
            <ImageBox title={'현재 기준 계기판 사진'} code={'C_DASHBOARD'} />
            <ImageBox title={'기타사진'} code={'C_ETC'} />
            <ImageBox title={'개인정보 동의서'} code={'C_CONSENT'} />
          </div>
          {warrantyData?.partnerInfo.map((partnerData) => {
            return (
              <div key={partnerData.partnerId}>
                <div className="section_title relative flex align-contents-center justify-content-center">
                  <p className="m-0">
                    [{partnerData.partnerName}] 입고점검사진
                  </p>
                </div>
                <div className="imageWrap">
                  <ImageBox
                    partnerData={partnerData.partnerDocuments}
                    partner={true}
                    title={'소견서'}
                    code={'P_OPINION'}
                  />
                  <ImageBox
                    partnerData={partnerData.partnerDocuments}
                    partner={true}
                    title={'입고 차량전면사진'}
                    code={'P_FRONT'}
                  />
                  <ImageBox
                    partnerData={partnerData.partnerDocuments}
                    partner={true}
                    title={'입고 계기판사진'}
                    code={'P_DASHBOARD'}
                  />
                  <ImageBox
                    partnerData={partnerData.partnerDocuments}
                    partner={true}
                    title={'점검사진'}
                    code={'P_CHECK'}
                  />
                </div>
              </div>
            );
          })}
        </div>
        <div className="">
          <div className="claim claim_paper_wrapper">
            {warrantyData?.partnerInfo.map((partnerData) => {
              return (
                <div className="inner" key={partnerData?.partnerId}>
                  <div className="section_title">
                    <p>[{partnerData.partnerName}] 수리 완료 사진</p>
                  </div>
                  <div className="imageWrap">
                    <ImageBox
                      partnerData={partnerData.partnerDocuments}
                      partner={true}
                      repairCenter={true}
                      title={'보험금청구동의서'}
                      code={'P_INSURANCE_TEMPLATE'}
                      // wide={true}
                    />
                    <ImageBox
                      partnerData={partnerData.partnerDocuments}
                      partner={true}
                      repairCenter={true}
                      title={'승인견적서'}
                      code={'P_APPROVED'}
                    />
                    <ImageBox
                      partnerData={partnerData.partnerDocuments}
                      partner={true}
                      repairCenter={true}
                      title={'사업자등록증'}
                      code={'P_REGISTRATION'}
                    />
                    <ImageBox
                      partnerData={partnerData.partnerDocuments}
                      partner={true}
                      repairCenter={true}
                      title={'사업자통장사본'}
                      code={'P_BANKBOOK'}
                    />
                    <ImageBox
                      partnerData={partnerData.partnerDocuments}
                      partner={true}
                      repairCenter={true}
                      title={'기타'}
                      code={'P_ETC'}
                    />
                    <ImageBox
                      partnerData={partnerData.partnerDocuments}
                      partner={true}
                      repairCenter={true}
                      title={'정비사진'}
                      code={'P_MAINTENANCE'}
                      // wide={true}
                    />
                  </div>
                </div>
              );
            })}
            {/* <div className="inner paper flex justify-content-center">
              <table className="bg-white">
                <thead>
                  <tr>
                    <th colSpan="6" className="header">
                      마감정보
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="subject">청구일</td>
                    <td colSpan="5" className="content">
                      <div className=" grid lg:col-4 col align-items-center">
                        <div className="w-18rem">
                          <Calendar
                            value={insuranceInfo.completeDate}
                            onChange={(e) =>
                              setInsuranceInfo({
                                ...insuranceInfo,
                                completeDate: e.target.value,
                              })
                            }
                            dateFormat="yy-mm-dd"
                            showButtonBar
                            showIcon
                            mask="9999-99-99"
                            placeholder="청구일 선택"
                            className="w-18rem"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="subject">보험사</td>
                    <td className="content">
                      {findLabelByCode(insuranceList, insuranceInfo.code)}
                    </td>
                    <td colSpan="2" className="subject">
                      증권번호
                    </td>
                    <td colSpan="2" className="content">
                      {insuranceInfo.insurancePolicyNumber || '-'}
                    </td>
                  </tr>
                  <tr>
                    <td className="subject">총 지급액</td>
                    <td colSpan="4" className="content">
                      {!!insuranceInfo.paymentAmt
                        ? `${formatNumber(insuranceInfo.paymentAmt)}원`
                        : '-'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingDialog;

const FUNNELS_TYPE = [
  { value: 'WC', label: '전화 / 소비자' },
  { value: 'WS', label: '전화 / 딜러' },
  { value: 'WE', label: '전화 / 기타' },
  { value: 'AC', label: '앱 / 소비자' },
  { value: 'AS', label: '앱 / 딜러' },
  { value: 'AE', label: '앱 / 기타' },
];
